import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";

const SalesReturnForm = (props) => {
  const frmRef = useRef({});

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [salesData, setSalesData] = useState("");
  const [invoiceData, setInvoiceData] = useState("");
  const [data, setData] = useState("");
  const [subTotalAmount, setSubTotal] = useState(0);

  const [totalAmt, setTotalAmt] = useState(0);

  const [taxs, setTaxs] = useState([]);
  const [taxId, setTaxId] = useState();
  const [taxAmount, setTaxAmount] = useState(0);

  const [totals, setTotals] = useState({});
  const [costInWords, setCostInWords] = useState(0);

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        //console.log(lat, long);
        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const { sendRequest: getSalesOrder } = useHttp();

  useEffect(() => {
    getSalesOrder(
      {
        url: `/api/salesOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&regionId=2`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setSalesData(res);
        }
      }
    );
  }, [getSalesOrder]);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const handleTaxChange = (e) => {
    setTaxId(e.target.value);
    // //console.log(e.target.value);
  };
  useEffect(() => {
    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(taxId))
        .map((item) => item.taxPercentage);

    const taxAmt =
      (parseFloat(subTotalAmount) / 100) * parseFloat(filteredTaxPer) || 0;

    //  //console.log(taxAmt);
    setTaxAmount(parseFloat(taxAmt).toFixed(2));
  }, [taxId, subTotalAmount]);

  useEffect(() => {
    const grandTotal = parseFloat(subTotalAmount) + parseFloat(taxAmount);
    //console.log("grandTotal");
    setTotalAmt(grandTotal);
  }, [taxAmount]);

  const handleSalesIdChange = (e) => {
    const id = e.target.value;
    //console.log(id);

    loadInvoiceData(id);
  };

  const { sendRequest: getSalesInvoice } = useHttp();

  const loadInvoiceData = (id) => {
    if (id) {
      getSalesInvoice(
        {
          url: `/api/salesInvoice/?orgId=${localStorage.getItem("orgId")}`,
        },
        (res) => {
          if (res) {
            //setInvoiceData(res);
            //console.log(res);

            const filterInvoice =
              res && res.filter((item) => item.salesOrderId == id);
            //   //console.log(filterInvoice);
            setInvoiceData(filterInvoice);
          }
        }
      );
    }
  };
  const handleInvoiceId = (e) => {
    // //console.log(e.target.value);

    const id = e.target.value;
    if (id) {
      const selectedId =
        invoiceData && invoiceData.filter((item) => item.salesInvoiceId == id);
      //console.log(selectedId);

      setData(selectedId);
    }
  };
  useEffect(() => {
    loadData();
  }, [data]);

  const loadData = () => {
    frmRef.current.customer_id.value = data && data[0].customerId;
    frmRef.current.dnd_id.value = data && data[0].dndId;

    frmRef.current.delivery_date.value = moment(
      data && data[0].deliveryDate,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");

    setProductDetails(data && data[0].salesInvoiceProducts);
    //console.log(data && data[0].salesInvoiceProducts);
    const id = parseInt(data && data[0].customerId);
    setTaxAmount(data && parseFloat(data[0].taxAmount));
    setSubTotal(data && parseFloat(data[0].totalAmount));
    setTotalAmt(data && parseFloat(data[0].totalSalesInvoiceValue));
    setTaxId(data && parseFloat(data[0].taxId));
    loadCustomerData(id);
  };

  const { sendRequest: getCustomer } = useHttp();

  const loadCustomerData = (id) => {
    if (id) {
      getCustomer(
        {
          url: `/api/customer/?orgId=${localStorage.getItem(
            "orgId"
          )}&customerId=${id}`,
        },
        (res) => {
          if (res) {
            //console.log(res);

            frmRef.current.customer_name.value = res && res.name;
            frmRef.current.email.value = res && res.emailId;
            frmRef.current.work_contact.value = res && res.workContactNumber;
            frmRef.current.contact_person_name.value =
              res && res.contactPersonDetails[0].name;
          }
        }
      );
    }
  };

  const handleQuantityChange = (index, event) => {
    const value = parseFloat(event.target.value);

    const salesInvoiceQuantity = productDetails[index].salesInvoiceQuantity;

    if (value > salesInvoiceQuantity) {
      toast.success(
        "Balance Quantity cannot be greater than Sales Invoice Quantity"
      );

      return;
    } else {
      const newTotals = { ...totals };
      const quantity = Number(event.target.value);

      ////console.log("qty", quantity);
      const rate = productDetails[index].rate;
      ////console.log("rate", rate);
      const total = isNaN(quantity) ? 0 : quantity * rate;
      // newTotals[index] = total;

      const dis = productDetails[index].discount;
      //console.log(dis);

      const discountAmt = (total * dis) / 100;

      productDetails[index].subTotalAmount = isNaN(total) ? 0 : total;
      productDetails[index].discountAmount = isNaN(discountAmt)
        ? 0
        : discountAmt;
      productDetails[index].salesReturnQuantity = isNaN(quantity)
        ? 0
        : quantity;
      productDetails[index].totalLineAmount = isNaN(quantity)
        ? 0
        : total - discountAmt;

      const tamt = isNaN(quantity) ? 0 : total - discountAmt;

      newTotals[index] = tamt;

      //console.log(newTotals);

      setTotals(newTotals);

      const updatedProductDetails =
        productDetails &&
        productDetails.map((item, i) => {
          return {
            ...item,
            salesReturnProductId: generateId() + 1,
            salesReturnQuantity:
              i === index ? quantity : item.salesInvoiceQuantity,
          };
        });

      //console.log(updatedProductDetails);

      setProductDetails(updatedProductDetails);
    }
  };

  useEffect(() => {
    const newTotal = Object.values(totals).reduce(
      (accumulator, currentValue) => {
        return accumulator + currentValue;
      },
      0
    );

    setSubTotal(newTotal);
  }, [totals]);

  function generateId() {
    const currentDate = moment().format("YYYYMMDD");
    const currentTime = moment().format("HHmmss");
    return `${currentDate}${currentTime}`;
  }
  const { sendRequest: postSalesReturn } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      salesReturnDetails: [
        {
          salesReturnId: generateId(),

          salesReturnDate: moment(frmRef.current.date.value).format(
            "DD/MM/YYYY"
          ),
          totalAmount: subTotalAmount,
          taxAmount: taxAmount,
          totalReturnCostValue: frmRef.current.total_cost.value,
          amountChargeable: frmRef.current.amt_chargeable.value,
          conditionOfItem: frmRef.current.condition.value,
          reasonOfItem: frmRef.current.reason.value,
          salesReturnProducts: productDetails,
          remark: frmRef.current.remark.value,
          status: 1,
          invoiceStatus: 1,
          customerId: frmRef.current.customer_id.value,
          dndId: frmRef.current.dnd_id.value,
          salesInvoiceId: frmRef.current.sales_invoice_id.value,
          taxId: frmRef.current.tax.value,
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ],
    };
    ////console.log(data);
    postSalesReturn(
      {
        url: "/api/salesReturn/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success("Sales Return Add Successfully");
        props.addForm(false);
      }
    );
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "20%",
      borderRadius: "5px",
      maxWidth: "850px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sales Return Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_order_id"}>
                        {" "}
                        {"Sales order id"}
                      </label>
                      <select
                        id="sales_order_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["sales_order_id"] = el)}
                        required
                        onChange={handleSalesIdChange}
                      >
                        <option value={""}>Select</option>
                        {salesData &&
                          salesData.map((x) => (
                            <option key={x.salesOrderId} value={x.salesOrderId}>
                              {x.salesOrderCode}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"sales_invoice_id"}>
                        {"Sales Invoice id"}
                      </label>
                      <select
                        id="sales_invoice_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["sales_invoice_id"] = el)}
                        onChange={handleInvoiceId}
                        required
                      >
                        <option value={""}>Select</option>
                        {invoiceData &&
                          invoiceData.map((x) => (
                            <option
                              key={x.salesInvoiceId}
                              value={x.salesInvoiceId}
                            >
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"dnd_id"}>{"DnD id"}</label>
                      <input
                        type={"text"}
                        id={"dnd_id"}
                        required
                        ref={(el) => (frmRef.current["dnd_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"customer_id"}> {"Customer id"}</label>
                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>
                        {" "}
                        {"Customer Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"customer_name"}
                        required
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(Work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"delivery_date"}>
                        {" "}
                        {"Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"delivery_date"}
                        required
                        ref={(el) => (frmRef.current["delivery_date"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        value={subTotalAmount}
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        onChange={handleTaxChange}
                        value={taxId}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        value={taxAmount}
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        value={totalAmt}
                        disabled
                      />
                    </div>
                    <div className="">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        value={costInWords}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"condition"}>
                        {" "}
                        {"Condition of Item"}
                      </label>
                      <select
                        id="condition"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["condition"] = el)}
                      >
                        <option value="Good">Good</option>
                        <option value="Moderate">Moderate</option>
                        <option value="Bad">Bad</option>
                        <option value="Very Bad">Very Bad</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reason"}>{"Reason of Return"}</label>
                      <select
                        id="reason"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["reason"] = el)}
                      >
                        <option value="Defective">Defective</option>
                        <option value="Packaging issue">Packaging issue</option>
                        <option value="Quality Issue">Quality Issue</option>
                        <option value="Other(Input)">Other(Input)</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-bordered table-sm ">
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Sales Return Quantity</th>
                <th>Discount</th>
                <th>Discount Amount</th>
                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.lineSrNo}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.itemType}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.salesInvoiceQuantity}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={itm.salesReturnQuantity}
                          ref={(el) => (productRef.current["qtyBal"] = el)}
                          onChange={(event) => handleQuantityChange(i, event)}
                        />
                      </td>
                      <td>{itm.discount}</td>
                      <td>{itm.discountAmount}</td>

                      <td>{itm.unitAbbreviation}</td>

                      <td>{itm.totalLineAmount}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SalesReturnForm;
